import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import { getList, update } from './selecaoAutomaticaAction';

import List from './selecaoAutomaticaList';

class SAP extends Component {
  componentWillMount() {
    this.props.getList();
  }

  render() {
    return (
      <div>
        <Content>
          <List />
        </Content>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getList, update }, dispatch);
export default connect(
  null,
  mapDispatchToProps,
)(SAP);
